import { createEntityActions } from 'next/lib/collections';

export const TYPE = 'page';

export const { replace, patterns } = createEntityActions(TYPE);

export const replacePagePatternFor = path => action => {
  return patterns.replace(action) && action.payload.path === path;
};
